<!--
 * @Author: Zeng Zhi
 * @LastEditTime: 2023-11-14 11:49:06
 * @Description:
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="w-full h-full">
    <!-- <cardTitle title="摄像头列表" class="mb-10px" /> -->
    <el-table :data="tableData" class="text-14px w-full" height="100%" v-loading="!showVideo">
      <el-table-column
        prop="cameraAlias"
        show-overflow-tooltip
        label="摄像头名称"
      ></el-table-column>
      <el-table-column prop="onlineStatus" label="状态"> </el-table-column>
      <!-- <el-table-column
        prop="streamAddress"
        show-overflow-tooltip
        label="所在区域"
      ></el-table-column> -->
      <el-table-column label="操作" width="50">
        <template #default="{row}">
          <div @click.stop="viewDetail(row)" class="cursor-pointer !text-hex-4095e5">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <CameraInfo v-if="showCameraInfo" :visible.sync="showCameraInfo"></CameraInfo> -->
  </div>
</template>

<script>
// const CameraInfo = () => {
//   return import('./VideoInfo')
// }
import { CameraManagementApi, PointManagementApi } from '@wiz-api/haiguang'

const cameraManagement = new CameraManagementApi()
const pointManagement = new PointManagementApi()
export default {
  name: 'cockpit-videolist',
  // components: {
  //   CameraInfo,
  // },
  props: {
    sourceId: {
      type: String,
      defalut: '',
    },
    customProps: {
      type: Object,
      defalut: null,
    },
    cloudRender: {
      type: Object,
      defalut: null,
    },
    // 云渲染实例
    player: {
      type: Object,
      defalut: null,
    },
  },
  data() {
    return {
      tableData: [],
      showCameraInfo: false,
      // 定时器，发送请求获取摄像头状态
      timer: null,
      pointData: [], // 点位列表
      // markerId: '',
      currModel: '',
      showVideo: false,
    }
  },
  async created() {
    this.currModel = this.sourceId
    this.timer = setInterval(() => {
      this.getTableList()
    }, 60000)
    // console.log('当前的plaer实例为：', this.player, this.sourceId, this.customProps)
    await this.getPointList()
  },
  beforeDestroy() {
    this.showCameraInfo = false
    clearInterval(this.timer)
  },
  methods: {
    // 获取摄像头列表
    async getTableList() {
      const [err, res] = await cameraManagement.getCameraList({
        body: {
          maxResultCount: 999,
          skipCount: 0,
          sorting: '',
          tenantId: null,
          keyWords: '',
        },
      })
      // console.log(res, '摄像头列表')
      if (!err) {
        this.tableData = [...res.items] || []
        // 判断是否已经绑定点位
        _.forEach(this.tableData, (ele, index) => {
          this.tableData[index].status = false
          if (
            _.find(this.pointData, (item) => {
              ele.id === item.businessId ? (this.tableData[index].pointData = item) : ''
              return ele.id === item.businessId
            })
          ) {
            this.tableData[index].status = true
          }
        })
        this.showVideo = true
        // await this.drawMarker()
      }
    },
    // 获取点位列表
    async getPointList() {
      this.showVideo = false
      const parmas = {
        sceneId: this.currModel,
        // sceneId: '3a1226b2-2cb7-0d02-0aec-81031e3d5401',
        type: 1,
      }
      const [err, res] = await pointManagement.getScenePoints(parmas)
      // console.log(res, '点位列表')
      if (!err) {
        this.pointData = res
        await this.getTableList()
      } else {
        this.$message.error(res.message)
      }
    },

    async viewDetail(row) {
      // console.log('表格row点击事件', row)
      // this.drawMarker()
      if (this.customProps.loadModelStatus) {
        console.log('restoreAllItemColor')
      } else {
        this.$message.warning('当前模型尚未加载完成！')
        return
      }
      // 没有点位的摄像头，点击不切换视角
      if (row.pointData && JSON.parse(row.pointData.visualAngle)) {
        this.changeVisualAngle(JSON.parse(row.pointData.visualAngle))
      } else {
        this.$message.warning('当前设备暂无点位！')
      }
      this.$emit('transferEvent', {
        toCom: { code: 'VideoInfo', origin: 'VideoList', name: '摄像头信息' },
        type: 'openComponent',
        props: {
          videoRow: row,
        },
      })
      // const openEvent = new CustomEvent('openComponent', {
      //   detail: {
      //     toCom: {
      //       code: 'VideoInfo',
      //       origin: 'VideoList',
      //       name: '摄像头信息',
      //     },
      //     type: 'openComponent',
      //     props: {
      //       videoRow: row,
      //     },
      //   },
      // })
      // window.dispatchEvent(openEvent)
    },
    // 放置marker
    async drawMarker() {
      // const options = []
      // this.tableData.forEach(async (val) => {
      //   if (!(val.pointData && val.pointData.position && val.pointData.icon)) {
      //     console.log(`设备${val.cameraAlias}暂无点位`)
      //     return
      //   }
      //   const pos = val.pointData.position.split(',')
      //   const style = val.pointData.icon
      //   const imgId = await PlayerUtils.call(
      //     this.player.Native.GisMarker.loadImage,
      //     `data://../apps/HZ/icon/${style}`
      //   )
      //   const option = {
      //     pos, // 定位点，世界坐标，三维向量
      //     visible: true, // 显示隐藏状态
      //     size: [44, 63], // 整体尺寸，二维向量，-1表示不限制，自动大小
      //     nodeOffset: [-25, -60], // 相对定位点的偏移量，二维向量
      //     imgId, // 图片
      //     imgSize: [44, 63], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
      //     imgOffset: [0, 0], // 图片相对标记的偏移量
      //     text: '', // 文本
      //     // fontSize: 14.0, // 字体大小
      //     breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
      //     textOffset: [0, 0], // 文字相对标记的偏移量
      //     textColor: 0xffffffff, // 文本颜色
      //     title: '', // 标题
      //     titleFontSize: 18.0, // 标题文字大小
      //     titleColor: 0xffffffff, // 标题颜色
      //     userData: null, // 用户数据，仅帮外部系统保存数据
      //   }
      //   this.markerId = await this.player.Native.GisMarker.batchCreate([option])
      // options.push(option)
      // })
      // this.markerId = await this.player.Native.GisMarker.batchCreate(options)
    },

    // 切换视角
    async changeVisualAngle(item) {
      if (item) {
        const result = await this.cloudRender.Camera.moveCamera('CameraParam', item, 2)
        return
      }
      const pos = await this.player.Native.Camera.moveTo([0, 0, 0], [0, 0, 0], [0, 0, 0], 2)
    },
  },
}
</script>

<style lang="scss" scoped></style>
